import { type UseQueryResult, useQuery } from 'react-query';
import { MoneyEntitlementService } from '@wealthlane/api-services/wealthlane-award-settlement-service';
import { Wealthlane_AwardSettlementService_Dtos_MoneyEntitlementMethodDto } from '@wealthlane/api-services/wealthlane-award-settlement-service';

const useGetMoneyEntitlementExistingSetup = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardSettlementService_Dtos_MoneyEntitlementMethodDto[] | undefined,
  unknown
> => {
  const moneyEntitlementExistingSetup = useQuery(['getMoneyEntitlementExistingSetup'], async () => {
    return await handleRequest(
      MoneyEntitlementService.getApiAwardSettlementApiMoneyEntitlementsExistingSetup()
    );
  });

  return moneyEntitlementExistingSetup;
};

export default useGetMoneyEntitlementExistingSetup;
